module.exports = __webpack_public_path__ + "img/thumbnail_Wisent_m_normal.9473ae00.png";